import { getAttachmentPermissionLevelFromSharingLinkKind } from '../utils/getAttachmentPermissionLevelFromSharingLinkKind';
export default function createLinkModel(linkId, response) {
    if (!response || response.ResultCode !== 0 /* Success */) {
        return {
            linkId: linkId,
            fileName: null,
            permissionLevel: 0 /* None */,
            sharingInfo: {
                getSharingInfoSucceeded: false,
                canShareInternally: false,
                canShareExternally: false,
                expirationDate: null,
                ignoreExpirationDate: false,
                canRefreshExpiration: false,
            },
        };
    }
    var permissionLevel = getAttachmentPermissionLevelFromSharingLinkKind(response.SharingLinkKind);
    return {
        linkId: linkId,
        fileName: response.FileName,
        permissionLevel: permissionLevel,
        sharingInfo: {
            getSharingInfoSucceeded: true,
            canShareInternally: response.CanShareInternally,
            canShareExternally: response.CanShareExternally,
            expirationDate: response.ExpirationDate,
            ignoreExpirationDate: false,
            canRefreshExpiration: false,
        },
    };
}
//# sourceMappingURL=createLinkModel.js.map